import React, { useEffect, useRef, useState } from 'react';
import DataGrid from '@dataGrid';
import GridHeader from './GridHeader';
import { withStyles } from '@material-ui/core';
import StatusBar from '@dataGrid/components/StatusBar';
import { useDynamicRoutingValidationContext } from '../../context/DynamicRoutingValidationContext';

const styles = (theme) => ({
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${theme.AppBGColor}`,
    borderRadius: 4,
    marginBottom: 30
  },
  dataGrid: {
    flex: 1,
    minHeight: 150,
    height: '100%',
    maxHeight: '100%',
    border: `1px solid ${theme.AppBGColor}`,
    '& .ag-theme-material .ag-body-horizontal-scroll': {
      borderWidth: '0px'
    },
    [`&>.gridTheme-${theme.themeName}>.ag-theme-material.theme-${theme.themeName}`]: {
      height: '100%'
    },
    '& .statusBar': {
      display: 'none'
    },
    '& .ag-theme-material .ag-icon-checkbox-checked': {
      color: theme.HeaderSelectedText
    },
    '& .ag-theme-material .checkBoxHeader': {
      display: 'flex',
      paddingLeft: 24
    }
  }
});

const CustomGrid = ({
  classes,
  title,
  GridConfig,
  data,
  showSearchBar,
  showBulkEdit,
  onBulkUpdate,
  updatedPros,
  onGridReadyHandler,
  constructStatusBar,
  onCellValueChanged,
  onSelectionChanged,
  hideHeader
}) => {
  const gridConfig = useRef(new GridConfig());
  const [gridApi, setGridApi] = useState();
  const { excludedPros, toggleExcludedPro } = useDynamicRoutingValidationContext();
  const [quickFilterText, setQuickFilterText] = useState('');

  useEffect(() => {
    if (gridApi) {
      gridApi.excludedPros = excludedPros;
      gridApi.toggleExcludedPro = toggleExcludedPro;
      gridApi.updatedPros = updatedPros;

      gridApi.refreshCells({ force: true });
      gridApi.refreshHeader();
    }
  }, [gridApi, excludedPros, updatedPros]);

  const onGridReady = ({ api }) => {
    setGridApi(api);
    if (onGridReadyHandler) {
      onGridReadyHandler(api);
    }
  };

  const updateSearchText = (value) => {
    setQuickFilterText(value);
  };

  const { config } = gridConfig.current;
  return (
    <div className={classes.container}>
      {!hideHeader && (
        <GridHeader
          title={title}
          gridApi={gridApi}
          showSearchBar={showSearchBar}
          showBulkEdit={showBulkEdit}
          handleBulkUpdate={onBulkUpdate}
          updateSearchText={updateSearchText}
        />
      )}
      <div className={classes.dataGrid}>
        <DataGrid
          defaultColDef={config.defaultColDef}
          columnDefs={config.columns}
          config={config}
          rowData={data}
          onGridReady={onGridReady}
          quickFilterText={quickFilterText}
          rowSelection={config.rowSelection}
          onSelectionChanged={onSelectionChanged}
          onCellValueChanged={onCellValueChanged}
          panelLabel={
            constructStatusBar
              ? (data) => <StatusBar data={constructStatusBar(data, excludedPros)} disableFilter />
              : null
          }
        />
      </div>
    </div>
  );
};

export default withStyles(styles)(CustomGrid);
